/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from "react";
import _ from "lodash";
import Col from "../../UIcomponent/Column";
import DashboardProfile from "../../Component/Dashboard/DashboardProfile/DashboardProfile";
import DashboardSessionStatistics from "../../Component/Dashboard/DashboardSessionStatistics/DashboardSessionStatistics";
import DashboardReq from "../../Utility/Requester/DashboardReq";
import DashboardTransactions from "../../Component/Dashboard/DashboardTransactions/DashboardTransactions";
import DashboardCredit from "../../Component/Dashboard/DashboardCredit/DashboardCredit";
import LocalContext from "../../Context/LocalContetxt";
import LessonsList from "../../Component/Lessons/LessonsList/LessonsList";
import { ThemeContext } from "styled-components";
import { useLocation } from "react-router-dom";
import Modal from "../../UIcomponent/Modal";
import Section from "../../UIcomponent/Section";
import StyledButton from "../../UIcomponent/Button";
import PersianLogoType from "../../UIcomponent/Icon/PersianLogoType";
import { DashboardLayout } from "./styles";
import Metas from "../../Component/Metas";
import BannerView from "../../Component/BannerView";
import IncompletedLinks from "../../Component/Dashboard/IncompletedLinks";

import "./Dashboard.scss";
import ProfileReq from "../../Utility/Requester/ProfileReq";
import { connect } from "react-redux";
import actions from "../../redux/actions";

const TeacherDashboard = (props) => {
  const { fetchUpcomingSessions, sessions, isFetching } = props;

  const lang = useContext(LocalContext).lang;
  const location = useLocation();
  const config = useContext(LocalContext).config;
  const theme = useContext(ThemeContext);
  const [DashboardState, setDashboardState] = useState({
    avatar: config ? config.avatar : "",
    firstName: config ? config.firstName : "",
    lastName: config ? config.lastName : "",
    upComming: null,
    held: null,
    nonScheduled: null,
    credit: null,
    dataTillTomorrow: [],
  });
  const [WalletHistory, setWalletHistory] = useState([]);
  const [profile, setProfile] = useState(null);
  const [Wallet, setWallet] = useState([]);
  const [IncomeStats, setIncomeStats] = useState(null);
  const [calendarClicked, setCalendarClicked] = useState(false);
  const [reviewStats, setReviewStats] = useState(null);
  const [ShowSuccessRegisterModal, setShowSuccessRegisterModal] =
    useState(false);

  useEffect(() => {
    if (config && config.role) {
      ProfileReq.Profile()
        .then((res) => {
          setProfile(res.data);
        })
        .catch((err) => {});

      fetchUpcomingSessions(config.role);

      DashboardReq.GetWallet(config.role)
        .then((res) => {
          setWallet(res.data);
        })
        .catch((err) => {});
      DashboardReq.GetWalletHistory(config.role)
        .then((res) => {
          setWalletHistory(res.data);
        })
        .catch((err) => {});
      if (config.role == "Teacher") {
        DashboardReq.IncomeStats()
          .then((res) => {
            setIncomeStats(res.data);
          })
          .catch((err) => {});
        let ID = config.userID;
        DashboardReq.ReviewStats(ID).then((res) => {
          setReviewStats(res.data);
        });
      }
      if (location.state && location.state.teacherRegistered === true) {
        setShowSuccessRegisterModal(true);
      }
    }
  }, [config, location.state]);

  const chargeSubmit = () => {};

  return (
    <DashboardLayout xl={18} lg={18} md={20} sm={24} xs={24}>
      <Metas
        title="داشبورد مدرس | لینگوتاک"
        description="داشبورد مدرس | لینگوتاک"
      />

      <>
        <Col
          className="w__Dashboard__Info"
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
        >
          <Col
            className="l__Dashboard__Profile"
            xl={6.5}
            lg={7.5}
            md={6.5}
            sm={24}
            xs={24}
          >
            <DashboardProfile
              credit={Wallet && Wallet.Balance}
              theme={theme}
              firstName={DashboardState.firstName}
              lastName={DashboardState.lastName}
              avatar={DashboardState.avatar}
              reviewStats={reviewStats}
            />
          </Col>
          <Col
            xl={12.5}
            lg={11}
            md={10.5}
            sm={22}
            xs={22}
            className="l__Dashboard__SessionStatistics"
          >
            {config && (
              <DashboardSessionStatistics role={config && config.role} />
            )}
          </Col>
          <Col
            xl={4.5}
            lg={5}
            md={6.5}
            sm={7}
            xs={7}
            className="l__Dashboard__Credit"
          >
            {config && (
              <DashboardCredit
                credit={Wallet && Wallet.Balance}
                chargeSubmit={chargeSubmit}
              />
            )}
          </Col>
        </Col>
        {profile?.ApplicationStatus < 7 && <IncompletedLinks />}
        <Col
          className="w__Dashboard__Section"
          xl={24}
          lg={24}
          md={24}
          sm={22}
          xs={22}
        >
          {config && config.userID === 14 && (
            <BannerView
              title={`${config.firstName} عزیز، شما میتوانید برنامه کلاس‌های خود را به تقویم گوگل اضافه کنید تا یادآوری کلاس‌ها را علاوه بر پیامک، از طریق Google Calendar در موبایل نیز دریافت نمایید.`}
              action="افزودن برنامه کلاس‌ها به تقویم گوگل"
              onActionClick={() => {
                setCalendarClicked(true);
                DashboardReq.calendars()
                  .then((res) => (window.location.href = res.data.Link))
                  .catch((e) => {
                    setCalendarClicked(false);
                  });
              }}
              disabled={calendarClicked}
            />
          )}
        </Col>

        <Col
          className="w__Dashboard__Section"
          xl={24}
          lg={24}
          md={24}
          sm={22}
          xs={22}
        >
          {config && (
            <LessonsList
              theme={theme}
              lang={lang}
              loading={isFetching}
              data={sessions}
            />
          )}
        </Col>
        {config && config.role === "Teacher" && (
          <Col
            className="w__Dashboard__Section"
            xl={24}
            lg={24}
            md={24}
            sm={22}
            xs={22}
          >
            <DashboardTransactions
              WalletHistory={WalletHistory}
              IncomeStats={IncomeStats}
            />
          </Col>
        )}
      </>
      <Modal visible={ShowSuccessRegisterModal}>
        <Section className="c__Dashboard__teacherRegistered">
          <PersianLogoType
            width="420"
            height="110"
            fontSize="6em"
            fill={theme.lightGray}
          />
          <Col>
            {config &&
              `${config.firstName} عزیر ، ثبت نام شما انجام شد. ظرف 24 ساعت آینده برای تکمیل ثبت نام با شما تماس گرفته خواهد شد.`}
          </Col>
          {
            <StyledButton
              width={120}
              primary
              onClick={() => setShowSuccessRegisterModal(false)}
            >
              متوجه شدم
            </StyledButton>
          }
        </Section>
      </Modal>
    </DashboardLayout>
  );
};
const mapStateToProps = (state) => ({
  isFetching: state.dashboard.upcommingSessions.fetching,
  sessions: state.dashboard.upcommingSessions.data,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUpcomingSessions: (role) =>
    dispatch(actions.dashboard.upcommingSessions.fetch(role)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeacherDashboard);
